import { FIELDS } from '@/pages/Invoices/components/InvoiceLines/constants';

const defaultFields = [
  // {
  //   field: 'commands',
  //   title: ' ',
  //   cell: 'commands',
  //   headerCell: 'commandsHeader',
  //   sortable: false,
  //   hidden: false,
  //   locked: true,
  //   width: 40,
  // },
  {
    key: 'Id',
    field: FIELDS.ID,
    title: 'Line No',
    label: 'Line No',
    sortable: true,
    hidden: false,
    width: 70,
  },
  {
    key: 'InvoiceId',  
    cell: 'navigation',
    field: FIELDS.INVOICE_ID,
    title: 'Invoice No',
    label: 'Invoice No',
    sortable: true,
    hidden: false,
    locked: true,
    width: 75,
  },
  {
    title: 'Qty',
    field: FIELDS.QUANTITY,
    cell: 'formatSeparator',
    width: 100,
  },
  {
    title: 'Reason',
    field: 'reason',
    cell: 'reason',
    hidden: true,
    width: 100,
  },
  {
    title: 'Comment',
    field: 'comment',
    cell: 'comment',
    hidden: true,
    width: 150,
  },
  {
    title: 'Part Number',
    field: FIELDS.PART_NUMBER,
    width: 200,
  },
  {
    title: 'Description',
    field: FIELDS.DESCRIPTION,
    width: 300,
  },
  {
    title: 'Mfr',
    field: FIELDS.MFR,
    width: 150,
  },
  {
    title: 'Date Code',
    field: FIELDS.DATE_CODE,
    width: 150,
  },
  {
    title: 'Lot Code',
    field: FIELDS.LOT_CODE,
    width: 150,
  },
  {
    title: 'Condition',
    field: FIELDS.CONDITION_NAME,
    width: 150,
  },
  {
    title: 'Price',
    field: FIELDS.PRICE,
    cell: 'formatCurrency',
    width: 100,
  },
  {
    title: 'Class',
    field: FIELDS.CLASS,
    width: 100,
  },
  {
    title: 'Package',
    field: FIELDS.PACKAGE,
    width: 100,
  },
  {
    field: 'deletecommands',
    title: ' ',
    cell: 'deletecommands',
    headerCell: 'commandsHeader',
    sortable: true,
    hidden: false,
    locked: true,
    width: 30,
  },
];

export default defaultFields;
